import React, { useContext } from 'react'
import { TicketListManagerContext } from '~/service/TicketListManager'
import classNames from 'classnames'
import { FormattedMessage } from '~/translations/utils'
import { post } from '~/utils/api'
import { useStore, Order } from '~/components/tickets/store'

type Props = {
  width: number
}

const TableHeader: React.FC<Props> = ({ width }) => {
  const { tickets, filter, setFilter, setItems } = useContext(
    TicketListManagerContext
  )
  const { view, order, checkedAll, setOrder, setCheckedAll } = useStore()
  const anyChecked = tickets.find(item => item.checked) ? true : false

  const sort = (name: Order) => {
    setOrder(name)
    setFilter({
      ...filter,
      order: name,
    })
  }

  const checkAll = () => {
    setItems(items =>
      items.map(ticket => ({ ...ticket, checked: !checkedAll }))
    )
    setCheckedAll(!checkedAll)
  }

  const changeState = type => {
    const ids = tickets.filter(item => item.checked).map(item => item.id)
    post(`tickets/state/${type}`, { ids: ids })
  }

  return (
    <>
      <div className="list-table-header">
        <div className="ticket-list-table-header-col">
          <label className="checkbox mr-2">
            <input
              type="checkbox"
              checked={checkedAll}
              onChange={e => checkAll()}
            />
          </label>
        </div>
        <div className="ticket-list-table-header-col ticket-list-table-header-col-tools">
          {!filter.categoryStatus && (
            <>
              {view != 'closed' && filter.view != 'closed' ? (
                <button
                  className="button is-small ticket-list-table-header-button"
                  onClick={() => changeState('close')}
                  disabled={!anyChecked}
                >
                  <FormattedMessage id="tickets / header / close" />
                </button>
              ) : (
                <button
                  className="button is-small ticket-list-table-header-button"
                  onClick={() => changeState('open')}
                  disabled={!anyChecked}
                >
                  <FormattedMessage id="tickets / header / reopen" />
                </button>
              )}
            </>
          )}
        </div>
        <div className="ticket-list-table-header-col ticket-list-table-header-col-right">
          <div className="ticket-list-table-header-date">
            {width > 900 && (
              <div className={'ticket-list-table-header-assigned'}>
                <FormattedMessage id="tickets / header / assigned" />
              </div>
            )}
            {width > 900 && (
              <a
                className={classNames('ticket-list-table-header-date-link', {
                  active: order.includes('created'),
                })}
                href="#"
                onClick={e => {
                  e.preventDefault()
                  order == 'createdDesc'
                    ? sort('createdAsc')
                    : sort('createdDesc')
                }}
              >
                <FormattedMessage id="tickets / header / createdAt" />
                {order.includes('created') && (
                  <span
                    className={classNames(
                      'fa',
                      { 'fa-caret-up': order == 'createdAsc' },
                      { 'fa-caret-down': order == 'createdDesc' }
                    )}
                  />
                )}
              </a>
            )}
            <a
              className={classNames('ticket-list-table-header-date-link', {
                active: order.includes('activity'),
              })}
              href="#"
              onClick={e => {
                e.preventDefault()
                order == 'activityDesc'
                  ? sort('activityAsc')
                  : sort('activityDesc')
              }}
            >
              <FormattedMessage id="tickets / header / lastActivity" />
              {order.includes('activity') && (
                <span
                  className={classNames(
                    'fa',
                    { 'fa-caret-up': order == 'activityAsc' },
                    { 'fa-caret-down': order == 'activityDesc' }
                  )}
                />
              )}
            </a>
          </div>
        </div>
      </div>
    </>
  )
}

export default TableHeader
